import React from 'react';
import { useLocation } from 'react-router-dom';
import html2pdf from "html2pdf.js";
import html2canvas from "html2canvas";
import '../css/success.css';
import logo from '../assets/logo2.png';
import logoo from '../assets/logoo.png';

const Success = () => {
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);

  // Extract values properly
  const email = urlParams.get('email');
  const phoneNumber = urlParams.get('phoneno');
  const estate = urlParams.get('estate');
  const customerId = urlParams.get('Customer_id'); // Assuming this is the payment reference
  const customerName = urlParams.get('Customer_name');
  const customerAddress = urlParams.get('Customer_address');
  const meterId = urlParams.get('Meter_id');
  const meterType = urlParams.get('Meter_type');
  const totalPaid = urlParams.get('Total_paid');
  const totalUnit = urlParams.get('Total_unit');
  const unit = urlParams.get('Unit');
  const price = urlParams.get('Price');
  const rate = urlParams.get('Rate');
  const token = urlParams.get('Token');
  const genTime = urlParams.get('Gen_time');

  const generateFileName = () => {
    return `Receipt_${customerName || 'Unknown'}_${customerId || 'Ref'}.pdf`;
  };

  const handleSaveAsPDF = () => {
    const element = document.getElementById("receipt");
    const options = {
      margin: 0.5,
      filename: generateFileName(),
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    };
    html2pdf().from(element).set(options).save();
  };

  const handleShare = async () => {
    const element = document.getElementById("receipt");

    try {
      // Convert receipt to image using html2canvas
      const canvas = await html2canvas(element);
      const imgData = canvas.toDataURL("image/png");

      // Convert image to a blob
      const response = await fetch(imgData);
      const blob = await response.blob();
      const file = new File([blob], `${generateFileName()}.png`, { type: "image/png" });

      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({
          files: [file],
          title: "Payment Receipt",
          text: `Here is my payment receipt for ${meterType}: ${meterId}`,
        });
      } else {
        alert("Sharing is not supported on your device.");
      }
    } catch (error) {
      console.error("Error sharing receipt:", error);
    }
  };

  return (
    <div className="container">
      <div className="receipt-container" id="receipt">
        <div className="receipt-content">
          <div className="text_message">
            <span className="message">Transaction Successful</span> 
            <img src={logo} alt="Logo" className="logo" />
          </div>
          <p><strong>Customer ID:</strong> {customerId}</p>
          <p><strong>Customer Name:</strong> {customerName}</p>
          <p><strong>Email:</strong> {email}</p>
          <p><strong>Customer Phone:</strong> {phoneNumber}</p> 
          <p><strong>Customer Address:</strong> {customerAddress}</p>
          <p><strong>Meter ID:</strong> {meterId}</p>
          <p><strong>Meter Type:</strong> {meterType}</p>
          <p><strong>Estate:</strong> {estate}</p>
          <p className="token"><strong className="tkn">Token: </strong> <strong>{token}</strong></p>
          <p className="price"><strong>Amount Paid:</strong> <span className="naira"> ₦{totalPaid}</span> </p>
          <p><strong>Total Unit:</strong> {totalUnit} {unit}</p>
          <p><strong>Unit Price:</strong> ₦{price}</p>
          <p><strong>Vat:</strong> {rate}</p>
          <p><strong>Date:</strong> {genTime}</p>
        </div>
        <div className="reciept_footer">
  <img src={logoo} alt="BlumenTech Logo" className="footer-logo" />
  <span>POWERED BY BLUMENTECH</span>
</div>
      </div>
      <div className="button-container">
        <button className="action-button" onClick={handleSaveAsPDF}>Save as PDF</button>
        <button className="action-button" onClick={handleShare}>Share</button>
      </div>
    </div>
  );
};

export default Success;
